import axios from 'axios';
import { construct, messageDisplay } from '../Auth/Util';



axios.defaults.withCredentials = true;
const apiClient = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL, 
});






// export async function pullNotificationEvent(){
//     const eventSource = new EventSource("http://localhost:8010/beepy/v1/stream", {
//       withCredentials: true,
//     })
//     eventSource.addEventListener("NEW_NOTIFICAION",(event) => {
//       const newEvent = JSON.parse(event.data);
//       console.log(newEvent);
//       return newEvent;
//     })
//     eventSource.onerror = (error) => {
//       console.log("SSE Connection error",error);
//       eventSource.close();
//     }
//     return () => {
//       eventSource.close();
//     }
// }






export async function pullNotification(name,email,phone,subject,message){
    return "Received";
}







export async function loginDB(obj){
    try{
          let response = await  axios.post(`${process.env.REACT_APP_BASE_URL}/n/vendorlogin`,{"email":sanitizeInput(obj.el),password:sanitizeInput(obj.ps)})
              console.log(response.data);
                 return response.data ? response.data['token'] : undefined;
           }catch(err){
                if(err.message){
                 console.log(err.message)
                return undefined
              }
      }
}





export async function loginOutDB(e){
    try{
          let response = await  axios.post(`${process.env.REACT_APP_BASE_URL}/n/logout`, {withCredentials: true },{"e":sanitizeInput(e)})
            if(response.status == 200){
              console.log(response.data);
            }
           }catch(err){
                if(err.message){
                 console.log(err.message)
                return undefined
              }
      }
}





export async function addToDB(name,mail,pass,phone,state,btype,plate,isAgree){
     try{
         let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/Vregistration`,
                        {vendName:sanitizeInput(name),
                        email:sanitizeInput(mail),
                        password:sanitizeInput(pass),
                        phone:sanitizeInput(phone.toString()),
                        state:sanitizeInput(state),
                        btype:sanitizeInput(btype),
                        platenumber:sanitizeInput(plate.toUpperCase()),
                        iagree:isAgree})
         return response.data;
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1);
                return undefined
              }
    }
}






export const passReset = async (obj) => {
    try{
        let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/reset`,
          {pass:sanitizeInput(obj.obj.pass),key:sanitizeInput(obj.obj.key)});
        return response.data;
    }catch(err){
          if(err.message){
            console.log(err.message)
            return undefined
         }
    }
}





export const run_search = async (obj) => {
       try{
          let response = await  apiClient.post("/search_members",{"node_id":sanitizeInput(obj)});
               return response.data['response'];
           }catch(err){
                if(err.message){
                 console.log(err.message)
                return undefined
              }
     }
}







export const pullData = async (obj) => {
    try{
        let response = await apiClient.post("/n/pullDetails",{key: sanitizeInput(obj.obj.key)});
            return response.data['response'];
       }catch(err){
          if(err.message){
                 console.log(err.message)
                return undefined
              }
    }
}





export async function Submit(name,email,phone,subject,message){
      let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/register`,
            {
              name:sanitizeInput(name),
              email:sanitizeInput(email),
              phone:sanitizeInput(phone),
              subject:sanitizeInput(subject),
              message:sanitizeInput(message)
            },
            {
          });
        return response.data['response'];
}







export async function earlysubmit(email){
      let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/earlymembers`,
            {e:sanitizeInput(email)},{});
        return response.data;
}











export async function getRequestToEmail(f){  
    try{
        let user = construct(localStorage.getItem(process.env.REACT_APP_LS));
         let response = await apiClient.post("/getAllLinkedRequest",
          {"email":sanitizeInput(user['em']),"offset":0,"fields":f,"i":sanitizeInput(user['vt']) === "Towing company" ? 1 : 0})
            if(response.data != undefined){
                if(response.data.rowCount == 0){
                  let response = await apiClient.post("/getAllLinkedRequest",
                    {"email":sanitizeInput(user['ph']),"offset":0,"fields":f,"i": sanitizeInput(user['vt']) === "Towing company" ? 1 : 0})
                    console.log(response.data.response);
                      return response.data.response;
                    }else{
                      return response.data.response;
                  }
              }else{
                messageDisplay("Empty",1)
              }
              
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}









export async function getRequestOustanding(){  
    try{
       let user = construct(localStorage.getItem(process.env.REACT_APP_LS));
        let response = await apiClient.post("/requestAmount",{"email":sanitizeInput(user['em'])})
            return response.data;  
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
         }
    }
}







//t for towing van while m is for (mechanic and motor ride)
export async function getRequestProfit(){  
    try{
      let user = construct(localStorage.getItem(process.env.REACT_APP_LS));
       if(user != null){ 
        let response = await apiClient.post("/requestProfit",
          {"email":sanitizeInput(user['em']),"ty":sanitizeInput(user['vt'].toString().includes("Towing company")) ? "t" : "m", "k":sanitizeInput(user['ph'])});
            return response.data;  
       }
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
         }
    }
}








export async function getRequestBeeppeePayout(){  
    try{
        let user = construct(localStorage.getItem(process.env.REACT_APP_LS));
        let response = await apiClient.post("/requestAccount",{"email":sanitizeInput(user['em'])})
          console.log(response.data);
            return response.data;  
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}







export async function requestAccountReset(e){  
    try{
        let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/vendorpasswordreset`,{"email":sanitizeInput(e)})
          console.log(response.data);
            return response.data;  
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}











export async function getRequestData(val){  
  // console.log(val);
  // console.log(val.substring(9,20));
  // console.log(val.substring(20,27));
  // console.log(val.substring(27));
    try{
        if(construct(localStorage.getItem(process.env.REACT_APP_LS)) != null){
         let response = await axios.post(process.env.REACT_APP_BASE_URL+"/gethelpdata",{"auth":sanitizeInput(val.substring(20,27)),
              "email":sanitizeInput(construct(localStorage.getItem(process.env.REACT_APP_LS))['ph'])},
              {headers: {'Authorization': `Bearer @${val.substring(27)}`}})                                                            
                return response.data;
        }else{
          return [];
        }
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}





export async function engageOrder(val){    
    try{
       if(construct(localStorage.getItem(process.env.REACT_APP_LS)) != null){      
         let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/engageOrder`,
          {"requestId":sanitizeInput(val.requestId.toString()),"sessionId":sanitizeInput(val.sessionId.toString()),
            "email":sanitizeInput(construct(localStorage.getItem(process.env.REACT_APP_LS))['em'])},{
              headers: {'Authorization': `Bearer @${window.location.href.toString().substring(window.location.href.indexOf("console")).substring(27)}`}
              })
              console.log(response.data);
            return response.data;
          }else{
            return "Error Pls signin to confirm order";
          }
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}












export async function completedOrder(val){    
    try{
       if(construct(localStorage.getItem(process.env.REACT_APP_LS)) != null){
         let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/completeOrder`,
          {"requestId":sanitizeInput(val.requestId.toString()),"email":sanitizeInput(construct(localStorage.getItem(process.env.REACT_APP_LS))['em'])},{
              headers: {'Authorization': `Bearer @${window.location.href.toString().substring(window.location.href.indexOf("console")).substring(27)}`}
            })
            console.log(response.data);
          return response.data;
         }
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}








export async function cancelOrder(val){    
    try{
       if(construct(localStorage.getItem(process.env.REACT_APP_LS)) != null){
          let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/cancelOrder`,
            {"requestId":sanitizeInput(val.requestId.toString()),"email":sanitizeInput(construct(localStorage.getItem(process.env.REACT_APP_LS))['em'])},{
              headers: {'Authorization': `Bearer @${window.location.href.toString().substring(window.location.href.indexOf("console")).substring(27)}`}
            })
                messageDisplay(response.data,1);
              return response.data;
          }
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}






export async function vefiryOrderPhone(val){    
    try{
         let response = await apiClient.post("/verifyOrderphoneNumber",{"requestId":sanitizeInput(val.requestId.toString())},{
              headers: {'Authorization': `Bearer @${window.location.href.toString().substring(window.location.href.indexOf("console")).substring(27)}`}
            })
            console.log(response.data);
            
          return response.data;
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
                return undefined
              }
    }
}








let count = 0;
export async function addLocation(obj,i,navigate){    
     try{
       if(construct(localStorage.getItem(process.env.REACT_APP_LS)) != null){ 
         let user = construct(localStorage.getItem(process.env.REACT_APP_LS));
           let response = await apiClient.post("/addVendorLocation",{"email":user['em'],latitude:sanitizeInput(obj.latitude.toString()),longitude:sanitizeInput(obj.longitude.toString()),changes:i})
            return response.data;
          }else{
             if(count <= 0){
                 navigate("/signin");
                 messageDisplay("Session Expired, Pls Login.",1)
                  count++;
             }
          }
         }catch(err){
            if(err.message){
               if(count <= 0){
                   if(err.message == "Request failed with status code 403"){
                      navigate("/signin");
                       messageDisplay("Session Expired, Pls Login.",1)
                    }
                      count++;
                }
              }
        }
    
}









export async function listtrackers(){    
     try{
         let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/listtrackers`,{});
          console.log(response.data);
          return response.data;
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
          }
    }
}







export async function getStarted(e){    
     try{
         let response = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/getStarted`,{"email":sanitizeInput(e.toString())});
          console.log(response.data);
          return response.data;
         }catch(err){
            if(err.message){
                 messageDisplay(err.message,1)
          }
    }
}









export async function unSubscribe(e){    
     try {
          console.log(`EM  ${e}`);
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/n/unsubscribeMarking`, {
            method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({"e":sanitizeInput(e.toString())}) 
          });
          if (response.ok) {
            console.log(`Successfully processed ID: ${e}`);
          }
        } catch (error) {
          console.error('Network error:', error);
        }
}









export const sendCart = async (pay,m) => {
    try{
        let res = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/attachTracker`,{"payload":pay,"ac":cleanUserdata(m)});
        if(res){
           messageDisplay(res.data, res.data.toString().includes("found") ? 1 : 0);
        }
      }catch(err){
         if(err.message){
            messageDisplay(err.message,1);
            return undefined
       } 
    }
}







export const sendCordinates = async (pay,m,f,msg,bat) => {
    try{
        let res = await axios.post(`${process.env.REACT_APP_BASE_URL}/n/sendCordinates`,{"l":pay,"k":m,"f":f,"msg":msg,"bat":bat});
        return res;
      }catch(err){
        if(err.message){
          messageDisplay(err.message,1);
          return undefined
      } 
   }
}







export const capFirst = (value) => {
  return value.toString().substring(0,1).toUpperCase()+value.toString().substring(1)
};







export const sanitizeInput = (value) => {
  let inputStr = value.toString();
   const dangerousPattern = /(?:<|select\b|insert\b|drop\b|delete\b)/i;
    const match = inputStr.match(dangerousPattern);
      if (match) {
        inputStr = inputStr.substring(0, match.index);
    }
  let cleanedValue = inputStr.toString().replace(/[^a-zA-Z0-9 .@]/g, '');
  return cleanedValue;
};







const cleanUserdata = (token) =>{
  if (!token) return '';
  return token.replace(/[^a-zA-Z0-9+/=]/g, '');
}






// let dec = decodeURIComponent(m);
// const paylaod = {    
//         merchantCode: process.env.REACT_APP_MC,
//         payItemID:  process.env.REACT_APP_ID,
//         customerEmail: 'johndoe@gmail.com',
//         redirectURL: 'http://localhost:3000',
//         text: 'Pay Now',
//         mode: 'TEST',
//         transactionReference: Date.now().toString(),
//         amount: total,
//         style: {
//             width: '90%',
//             height: '40px',
//             border: 'none',
//             color: '#fff',
//             backgroundColor: '#4287f5'
//         },
//         callback: (response) => {
//             //sendPurchase();
//            console.log(`response:  $response`)
//         }
//   }



  // getRequestData 
  // console.log(val);
  // console.log(val.substring(9,20));
  // console.log(val.substring(20,27));
  // console.log(val.substring(27));